import 'jquery';
import 'slick-carousel/slick/slick.min';
import 'bootstrap';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faFacebook, faTwitter, faPinterestP, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone, faHome, faSearch, faStar, faChevronDown } from '@fortawesome/free-solid-svg-icons';
library.add(faFacebookF, faFacebook, faPinterestP, faTwitter, faInstagram, faLinkedin, faEnvelope, faPhone, faSearch, faHome, faStar, faChevronDown); //faClock, faAcorn, faMap

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import learndashCpt from './routes/iframe';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  aboutUs,
  learndashCpt,
});
/**
 * Google Font loader
 * @type {Object}
 */
window.WebFontConfig = {
  google: { families: [ 'Open+Sans:400i,400,600' ] },
};
(function() {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js